<template>
    <AppLayout :contrast="true" title="Crear SLA">
        <Breadcrumb
            name="SLA de Envíos"
            routeName="sla_envios"
            page="Crear Sla"
        />
        <form class="p-2">
            <div class="flex flex-col lg:flex-row lg:w-full">
                <div
                    class="bg-white rounded-lg shadow p-5 m-2 lg:mx-4 lg:w-1/2"
                >
                    <div class="font-medium text-gray-600 text-lg mb-2">
                        Datos del Proveedor
                    </div>
                    <div class="flex flex-col h-24">
                        <label for="proveedor" class="my-1 text-gray-700"
                            >Proveedor<span class="text-red-400">*</span></label
                        >
                        <select
                            id="proveedor"
                            class="t-select"
                            v-model="form.proveedor_id"
                            required
                        >
                            <option selected="selected" disabled>
                                Seleccionar
                            </option>
                            <option
                                v-for="proveedor in proveedores"
                                :value="proveedor.id"
                                :key="proveedor.id"
                            >
                                {{ proveedor.nombre }}
                            </option>
                        </select>
                    </div>
                    <div class="flex flex-col h-24">
                        <label for="promesa" class="my-1 text-gray-700">
                            Promesa (Días)
                        </label>
                        <input
                            type="text"
                            id="promesa"
                            :class="[
                                't-input',
                                form.errors.promesa && 't-input-invalid',
                            ]"
                            v-model="form.promesa"
                            @focus="form.errors.promesa = null"
                        />
                        <small
                            v-if="form.errors.promesa"
                            id="promesa-help"
                            class="p-error"
                        >
                            {{ form.errors.promesa }}
                        </small>
                    </div>
                </div>
                <div
                    class="bg-white rounded-lg shadow p-5 m-2 lg:mx-4 lg:w-1/2"
                >
                    <div class="font-medium text-gray-600 text-lg mb-2">
                        Información del Cordon
                    </div>
                    <div class="flex flex-col h-24">
                        <label for="cordon" class="my-1 text-gray-700"
                            >Cordon Origen<span class="text-red-400"
                                >*</span
                            ></label
                        >
                        <select
                            id="cordon"
                            class="t-select"
                            v-model="form.cordon_origen_id"
                            required
                        >
                            <option selected="selected" disabled>
                                Seleccionar
                            </option>
                            <option
                                v-for="cordon in cordones"
                                :value="cordon.id"
                                :key="cordon.id"
                            >
                                {{ cordon.descripcion }}
                            </option>
                        </select>
                    </div>
                    <div class="flex flex-col h-24">
                        <label for="cordon" class="my-1 text-gray-700"
                            >Cordon Destino<span class="text-red-400"
                                >*</span
                            ></label
                        >
                        <select
                            id="cordon"
                            class="t-select"
                            v-model="form.cordon_destino_id"
                            required
                        >
                            <option selected="selected" disabled>
                                Seleccionar
                            </option>
                            <option
                                v-for="cordon in cordones"
                                :value="cordon.id"
                                :key="cordon.id"
                            >
                                {{ cordon.descripcion }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="m-4 flex justify-end">
                <Button @click.prevent="store"> Crear Promesa </Button>
            </div>
        </form>
    </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import { Link } from "@inertiajs/inertia-vue3";
import { Icon } from "@vicons/utils";
import { AngleRight } from "@vicons/fa";
import Breadcrumb from "@/shared/Breadcrumb.vue";
import Button from "@/shared/Button.vue";

export default {
    components: {
        AppLayout,
        Link,
        Icon,
        AngleRight,
        Breadcrumb,
        Button,
    },
    props: {
        proveedores: Array,
        cordones: Array,
    },
    data() {
        return {
            form: this.$inertia.form({
                proveedor_id: null,
                promesa: null,
                cordon_origen_id: null,
                cordon_destino_id: null,
            }),
        };
    },
    methods: {
        store() {
            this.form.post("/sla_envios");
        },
    },
};
</script>

<style scoped>
.p-inputtext:enabled:focus,
.p-password-input:enabled:focus {
    box-shadow: 0 0 0 1px #2e5f98;
    border-color: #2e5f98;
}
.p-inputtext:hover,
.p-password-input:hover {
    border-color: #829fc1;
}
</style>
